import React from 'react';
import { useTranslator } from 'tradera/lang/translate';
import type { PolymorphicComponent } from 'react-polymorphed';

type BidsLabelProps = {
    count?: number;
    className?: string;
};

export const BidsLabel: PolymorphicComponent<'span', BidsLabelProps> = ({
    className,
    as: Component = 'span',
    count
}) => {
    const { t } = useTranslator();

    return (
        <Component className={className}>
            {t('itemCard_numberOfBidsWithCount', { count })}
        </Component>
    );
};
